import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  background-color: ${BaSeTheme.colors.defaultColors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${BaSeTheme.stackOrder.normal};
  width: 100%;
  height: 100vh;
`;

export const Content = styled.div`
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  width: 100%;
  height: 100vh;

  button {
    margin: 16px 0px;
  }
`;

export const Separator = styled.hr`
  margin: 16px 0px;
  border: none;
  height: 2px;
  background: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
`;

export const NoteSelecionWrap = styled.div`
  margin-top: 45px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const NoteBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  left: 0px;
  top: 0px;
  background: ${BaSeTheme.colors.institucionais.cinzaSebrae97};
  border-radius: 4px;
`;

export const RangeLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-left: 30px;
`;

export const ButtonBox = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
`;

export const HistoryBox = styled.div`
  padding-bottom: 10px;
`;

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryItem = styled.span`
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 5px;
`;

export const HistoryItemCalibragem = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const Item = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const HistoryDialogHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryDialogContent = styled.div`
  max-height: 434px;
  overflow-y: auto;

  p {
    color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
  }
`;

export const HistoryDialogRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryDialogNote = styled.div`
  width: 62px;
  height: 24px;
  padding: 5px;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae97};
`;

export const HistoryDialogContentItem = styled.div`
  display: flex;
  gap: 5px;
`;

export const BoxCenter = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;
